export const COOKIE_CONSENT_STORE_NAME = 'cookie-consent-store';

export const COOKIE_CONSENT_ACTIONS = {
    RESET: 'cookie-consent/reset',
    SET_SERVICES: 'cookie-consent/set-services'
} as const;
